import React from 'react';
import ReactDOM from 'react-dom';

import { getStaticApiPath } from "common";
import { stateFix } from "logic/stateReducers";

import Store from 'store';

import Data from 'data';
import { loadData } from 'data/load';

export const dataLoaded = loadData(window.pll_current_language);

async function _loadProfile(id) {
  const url = getStaticApiPath(`load/${id}`);
  //const url = `https://laplanner.maxroll.gg/laplanner-data/load/${id}`;
  const state = await fetch(url).then(response => response.json());
  if (!state.embeds) return state;

  await dataLoaded;
  return stateFix(state);
}

const buildCache = {};
export function loadProfile(id) {
  if (buildCache[id]) return buildCache[id];
  return buildCache[id] = _loadProfile(id);
}

function embedIndex(state, id) {
  id = parseInt(id);
  if (isNaN(id)) return -1;
  return state.embeds.findIndex(embed => embed.id === id);
}

export async function renderProfile(node, profile, id, component) {
  let state = await loadProfile(profile);

  await dataLoaded;

  const store = new Store();
  const index = embedIndex(state, id);
  if (index >= 0) {
    state = {...state, activeEmbed: index};
  }
  const active = state.embeds[state.activeEmbed];
  if (active && active.items) {
    await Data.loadItems(Object.values(active.items).map(item => item?.id).filter(Boolean));
  }

  await store.setState(state);

  ReactDOM.render((
    <Store.Provider store={store}>
      {component}
    </Store.Provider>
  ), node);
}

export async function renderRapport(node, id, component) {
  await dataLoaded;
  console.log(dataLoaded);

  const npc = Data.npc[id];
  if (!npc) {
    throw Error('unknown NPC');
  }
  const ids = new Set();
  for (const r of npc.rewards) {
    if (!r) continue;
    for (const item of r) {
      ids.add(item.id);
    }
  }
  for (const a of npc.actions) {
    if (a.type === 1) {
      ids.add(a.id);
    }
  }
  await Data.loadItems([...ids]);

  const store = new Store();

  ReactDOM.render((
    <Store.Provider store={store}>
      {component}
    </Store.Provider>
  ), node);
}

export async function renderCollection(node, id, component) {
  await dataLoaded;

  const data = Data.collections[id];
  if (!data) {
    throw Error('unknown collection');
  }
  await Data.loadItems(Object.values(data).map(item => item.id));

  const store = new Store();

  ReactDOM.render((
    <Store.Provider store={store}>
      {component}
    </Store.Provider>
  ), node);
}
